
import Giotanks from "../views/Giotanks/Giotanks";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";

export const customerRoutes = [
  {
    collapse: true,
    name: "Cliente",
    icon: AccessibilityNewIcon,
    state: "customerCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "CUSTOMER",
    views: [
      {
        path: "/giotanks",
        name: "Giotanks",
        mini: "GTK",
        component: Giotanks,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "CUSTOMER",
      },
    ],
  },
]